package com.dwarshb.bms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.navigation.NavHostController
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.rememberNavController
import app.cash.sqldelight.db.SqlDriver
import com.dwarshb.bms.authentication.AuthenticationView
import com.dwarshb.bms.authentication.AuthenticationViewModel
import com.dwarshb.firebase.Firebase
import com.dwarshb.firebase.FirebaseUser
import com.dwarshb.firebase.onCompletion

enum class Screen {
    Home,Auth,CreateTrip,JoinTrip,TripReview,TripReservation,TicketConfirmation,TripDashboard,
    GetTicket,BusRequest
}

@Composable
fun TripOrganizerApp(sqlDriver: SqlDriver?,
                     deepLinkUrl: String,
                     navController: NavHostController = rememberNavController()) {
    var selectedTrip by remember { mutableStateOf(Trip()) }
    var bookingConfirmation by remember { mutableStateOf(Booking()) }
    var firebaseUser by remember { mutableStateOf(FirebaseUser("", "", "")) }
    var viewModel = TripViewModel()

    val API_KEY = "AIzaSyDzPYvGMKagugkZI3k4dTAuEPexIm4TBlQ"//"AIzaSyA4mmg2LvJMNkljUnIFV7SJRgWlvnHG1-Q"
    val DATABASE_URL = "https://project-24-54ac6.firebaseio.com/"//"https://fitnessconnect-3e757-default-rtdb.firebaseio.com"
    val STORAGE_URL = "https://firebasestorage.googleapis.com/v0/b/bytecamp-bb28c.appspot.com/o"
    val firebase = Firebase()
    firebase.initialize(apiKey = API_KEY, databaseUrl = DATABASE_URL,storageUrl = STORAGE_URL)

    val authenticationViewModel = viewModel { AuthenticationViewModel(firebase, sqlDriver) }
    authenticationViewModel.checkSession(object : onCompletion<User> {
        override fun onSuccess(T: User) {
            firebaseUser = FirebaseUser(
                T.email, T.idToken, T.localId.toString()
            )
            authenticationViewModel.firebase?.setCurrentUser(firebaseUser)
        }

        override fun onError(e: Exception) {
            e.printStackTrace()
        }
    })

    val code = Utils.getQueryParameter(deepLinkUrl,"code")?:""
    val busRequest = Utils.getQueryParameter(deepLinkUrl,"busRequest")?:""

    val startDestination =
        if (code.isNotEmpty()) Screen.JoinTrip.name
        else if(busRequest.isNotEmpty()) Screen.BusRequest.name
        else Screen.Home.name

    var languageCode by remember { mutableStateOf("en") }
    var language by remember { mutableStateOf("English") }

    CompositionLocalProvider(LocalLocalization provides languageCode) {
        NavHost(
            navController = navController,
            startDestination = startDestination,
        ) {
            composable(route = Screen.BusRequest.name) {
                BusBookingFormCreative {
                    navController.navigate(Screen.Home.name)
                }
            }
            composable(route = Screen.Auth.name) {
                AuthenticationView(authenticationViewModel,
                    onBackPressed = { navController.popBackStack() }) {
                    firebaseUser = it
                    navController.navigate(Screen.Home.name)
                }
            }
            composable(route = Screen.Home.name) {
                HomeScreen(
                    tripViewModel = viewModel,
                    createTrip = { navController.navigate(Screen.CreateTrip.name) },
                    joinTrip = {
//                selectedTrip = it Fetch Trip based on tripid
                        navController.navigate(Screen.JoinTrip.name)
                    },
                    onSignInClick = {
                        navController.navigate(Screen.Auth.name)
                    },
                    onGetTicketDetails = {
                        navController.navigate(Screen.GetTicket.name)
                    },
                    onLanguageChange = {
                        when(it) {
                            "Gujarati" -> {
                                languageCode = "gu"
                                changeLang("gu")
                            }
                            "Hindi" -> {
                                languageCode = "hi"
                                changeLang("hi")
                            }
                            else -> {
                                languageCode = "en"
                                changeLang("en")
                            }
                        }
                    },
                    navigateToTripReservation = {
                        selectedTrip = it
                        navController.navigate(Screen.TripDashboard.name)
                    })
            }
            composable(route = Screen.CreateTrip.name) {
                CreateTripScreen(
                    authenticationViewModel = authenticationViewModel,
                    onTripCreated = {
                        selectedTrip = it
                        navController.navigate(Screen.TripReview.name) {
                            popUpTo(Screen.CreateTrip.name) { inclusive = true }
                        }
                    },
                    onBackPressed = {
                        navController.navigate(Screen.Home.name) {
                            popUpTo(Screen.Home.name) { inclusive = true }
                            launchSingleTop = true
                        }
                    })
            }
            composable(route = Screen.JoinTrip.name) {
                JoinTripScreen(viewModel,
                    tripCode = code,
                    onJoin = {
                        selectedTrip = it
                        navController.navigate(Screen.TripReservation.name)
                    }, onBackPressed = {
                        navController.navigate(Screen.Home.name) {
                            popUpTo(Screen.Home.name) { inclusive = true }
                            launchSingleTop = true
                        }
                    })
            }
            composable(route = Screen.TripReview.name) {
                TripCreated(trip = selectedTrip, onBackPressed = { navController.popBackStack() })
            }
            composable(route = Screen.TripReservation.name) {
                viewModel.getReservations(selectedTrip.id)
                var bookings = viewModel.bookings.collectAsState()
                ReserveSeat(
                    trip = selectedTrip,
                    bookings = bookings,
                    requestTicket = {
                        viewModel.requestBooking(it) { booking ->
                            if (booking != null) {
                                bookingConfirmation = booking
                                navController.navigate(Screen.TicketConfirmation.name)
                            }
                        }
                    },
                    onBackPressed = { navController.popBackStack() })
            }
            composable(route = Screen.TicketConfirmation.name) {
                if (bookingConfirmation.tripId.isNotEmpty()) {
                    TicketConfirmationScreen(
                        trip = selectedTrip,
                        booking = bookingConfirmation,
                        onBack = { navController.popBackStack(Screen.Home.name, false, false) }
                    )
                }
            }
            composable(route = Screen.TripDashboard.name) {
//                viewModel.getReservations(selectedTrip.id)
                TripDashboardScreen(selectedTrip, viewModel, onBack = {
                    navController.navigate(Screen.Home.name) {
                        popUpTo(Screen.Home.name) { inclusive = true }
                        launchSingleTop = true
                    }
                })
            }
            composable(route = Screen.GetTicket.name) {
                JoinTripScreen(viewModel,
                    joinTrip = false,
                    onGetTicketResult = { trip, booking ->
                        selectedTrip = trip
                        bookingConfirmation = booking
                        navController.navigate(Screen.TicketConfirmation.name)
                    },
                    onBackPressed = {
                        navController.navigate(Screen.Home.name) {
                            popUpTo(Screen.Home.name) { inclusive = true }
                            launchSingleTop = true
                        }
                    })
            }
        }
    }
}